module.exports = __webpack_public_path__ + "static/media/local-18@3x.7947e49b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/venues-and-open-hours/img/local-18@3x.png
// module id = 1185
// module chunks = 2